import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { VIBE_CHECK_OPTIONS } from '@/pages/Onboarding/options/VibeCheck/VIBE_CHECK_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenVibeCheck: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'VibeCheck',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const vibeCheck = form.watch('vibe_check');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['vibe_check']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        vibeCheck: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage>
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>What's the mood tonight?</OwnAiTitle>
        <OnboardingOptionsList>
          {VIBE_CHECK_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={vibeCheck === option.id}
              control={form.control}
              option={option}
              name="vibe_check"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`vibe-check-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
